import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-save-modal',
  templateUrl: './save-modal.component.html',
  styleUrls: ['./save-modal.component.scss']
})
export class SaveModalComponent {

    public title: string;
    public name: string;
    public originalName: string;
    constructor(private instance: NgbActiveModal) { }

    public Cancel(reason: any) {
        this.instance.dismiss(reason);
    }

    public Save() {
        this.instance.close(this.name);
    }

    public nameDisabled() {
        return this.name === this.originalName || this.name === '';
    }
}
